/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment, use, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Dropdown, Checkbox, Select, Tag, Radio, Space, Popover,
  Divider,
} from 'antd';
import {
  FilterOutlined, ControlOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import QualityCheckActions from '@Actions/quality/qualityCheckActions';
import AnalyticsActions from '@Actions/application/analyticsActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import Constants, { INFINITE_EXPIRY_DATE } from '@Apis/constants';
import H3DateSelector from '@Uilib/h3DateSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import SelectAppUser from '@Components/Common/SelectAppUser';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ApproveQC from './ApproveQC';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZModal from '../../../Common/UI/PRZModal';
import PRZText from '../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import ListScreenKeys from './mobileListHelpers';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import PRZSelect from '../../../Common/UI/PRZSelect';
import './style.scss';
import {
  toISTDate, dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '@Apis/constants';
import UserSavedFilterViewSelector from '@Components/Common/UserSavedFilterViewSelector';




const fixedColumns = ['QC_CODE', 'QUALITY_CHECK_POINT', 'OPERATION', 'REFRENCE_CODE', 'STATUS'];
const { Option } = Select;

/**
 *
 */
function ListQualityChecks({
  qualityChecks, qualityChecksLoading, user, getQualityChecks, history, getDownloadQualityChecks, MONEY, getQualityCheckReport, getQualityCheckReportLoading, downloadDocument, orgUsers, getOrgUsers, updateQualityCheckAssignees, priceMasking,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [showApproveQualityCheck, setShowApproveQualityCheck] = useState(false);
  const [qcData, setQCData] = useState({});
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedEntityType, setSelectedEntityType] = useState('');
  const [call, setCall] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-qc') ? JSON.parse(localStorage.getItem('prcz-page-columns-qc')) : {
    QC_CODE: {
      label: 'QC #',
      visible: true,
    },
    PRODUCT_NAME: {
      label: 'Product Name',
      visible: true,
    },
    SOURCE_LOCATION: {
      label: 'Source Location',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    QUALITY_CHECK_POINT: {
      label: 'Quality Rule Name',
      visible: true,
    },
    ASSIGNEES: {
      label: 'Assignees',
      visible: true,
    },
    REFERENCE_CODE: {
      label: 'Reference #',
      visible: true,
    },
    BATCH_QTY: {
      label: 'Batch Quantity',
      visible: true,
    },
    APPROVED_QTY: {
      label: 'Approved Quantity',
      visible: true,
    },
    REJECTED_QTY: {
      label: 'Rejected Quantity',
      visible: true,
    },
    BATCH_EXPIRY: {
      label: 'Batch Expiry',
      visible: true,
    },
    BATCH_COST_PRICE: {
      label: 'Batch Cost Price',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    COMPLETION_DATE: {
      label: 'Completion Date',
      visible: true,
    },
  });
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});
  const [selectedQCPointForMobile, setSelectedQCPointForMobile] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  // saved filter views states
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const processData = (data) => {
    setQCData(data);
  };

  const handleDrawerState = (data) => {
    setShowApproveQualityCheck(true);
    processData(data);
  };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getQualityCheckColumns = () => {
    const qualityCheckColumns = [
      {
        title: '',
        render: (record) => {
          const selectedUsers = record?.assignees?.map((assignee) => ({
            userId: assignee?.user_id,
            title: assignee?.first_name,
            identity: assignee?.identity,
          }));
          return (
            <div>
              <div className="mobile-list__card">
                <div className="mobile-list__card_header">
                  <div className="mobile-list__card_header-left">
                    <PRZText text={`#${record?.qc_number}`} className="mobile-list__card_item-number" />
                  </div>
                </div>
                <div className="mobile-list__card_body">
                  <div className="mobile-list__card_body-left">
                    {record?.entity_info?.product_sku_name && (
                      <div className="mobile-list__card_item-details">
                        {record?.entity_info?.product_sku_name}
                      </div>
                    )}
                    <PRZText
                      text={`Reference - ${record?.reference_id}`}
                      className="mobile-list__card_item-details"
                    />
                    <PRZText className="mobile-list__card_item-details" text={`Batch #${record?.approved_batch?.custom_batch_number}`} />
                    <PRZText className="mobile-list__card_item-details" text={`Quantity ${record?.original_qty} ${record?.entity_info?.uom_info?.uqc?.toProperCase()}`} />
                  </div>
                  <div className="mobile-list__card_header-right">
                    <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                      {record?.is_qc_on_hold ? 'On hold' : record.status?.toProperCase()}
                    </div>
                  </div>
                </div>
                <Divider className="mobile-list__card_divider" />
                <div className="mobile-list__card_footer">
                  <div className="mobile-list__card_footer-left">
                    {record?.assignees?.length > 0 ? (
                      <SelectUser
                        dontShowUnassigned
                        selectedUsers={selectedUsers}
                        disabled
                        removeAddUser
                      />
                    ) : (
                      '-'
                    )}

                    <div className="mobile-list__card_footer__actions-button_wrapper">
                      <Dropdown
                        placement="top"
                        menu={{
                          items: [
                            {
                              label: record?.status === 'COMPLETED' ? 'QC Report' : 'QC Requisition Slip',
                              key: 'download_qc',
                            },
                            {
                              label: 'Certificate of Analysis',
                              key: 'download_coa',
                              disabled: !record?.approved_qty,
                            },
                          ],
                          onClick: ({ key }) => {
                            switch (key) {
                              case 'download_qc':
                                getDownloadQualityChecks(record?.quality_control_rules?.tenant_id, record?.quality_check_id, '', '', user?.user_id);
                                break;
                              case 'download_coa':
                                if (record?.quality_check_id) {
                                  downloadDocument({
                                    url: `${Constants.QUALITY_CHECK_COA}?quality_check_id=${record?.quality_check_id}&tenant_id=${record?.quality_control_rules?.tenant_id}`,
                                    document_type: 'CERTIFICATE_OF_ANALYSIS',
                                    document_number: record?.quality_check_id,
                                    key: uuidv4(),
                                  });
                                }
                                break;
                              default:
                                break;
                            }
                          },
                        }}
                        arrow
                        trigger="click"
                      >
                        <span onClick={(e) => e.preventDefault()}>
                          <FontAwesomeIcon
                            icon={faDownload}
                          />
                        </span>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="mobile-list__card_footer-right">
                    <PRZText
                      className="mobile-list__card__view-more_wrapper"
                      onClick={() => {
                        setSelectedQCPointForMobile(record);
                        setMoreDetailsDrawer(true);
                      }}
                      text={(
                        <span className="mobile-list__card__view-more-text_wrapper">
                          <span className="mobile-list__card__view-more-text">More Info</span>
                          <FontAwesomeIcon
                            className="mobile-list__card__view-more-icon"
                            icon={faAnglesRight}
                          />
                        </span>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'QC #',
        render: (text, record) => (
          <div className="column-number__wrapper">
            <div className="">
              {record?.qc_number}
            </div>
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
              {record?.is_qc_on_hold ? 'On hold' : record.status?.toProperCase()}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.QC_CODE.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'SOURCE LOCATION',
        render: (record) => (
          <div>
            <H3Text text={record?.entity_info?.source_info?.tenant_name || ''} />
            <H3Text text={record?.entity_info?.source_info?.department || ''} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SOURCE_LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div>
            <H3Text text={record?.entity_info?.tenant_name} />
            <H3Text text={record?.entity_info?.department || ''} className="table-subscript" />
          </div>
        ),
        // record?.tenant_department_info?.alias_name,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'PRODUCT',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        width: '250px',
        render: (record) => (
          <Fragment>
            <div className="associated-entity">
              <div onClick={() => {
                setShowPRZModal(true);
                setCurrentProduct(record?.entity_info?.product_sku_id);
              }}
              >
                <a>
                  {`#${record?.entity_info?.internal_sku_code}`}
                </a>
              </div>
              <PRZModal
                isOpen={showPRZModal}
                onClose={() => {
                  setShowPRZModal(false);
                }}
                entityType="product"
                documentId={currentProduct}
              />
            </div>
            <div>
              {`${record?.entity_info?.ref_product_code ? `${record?.entity_info?.ref_product_code} - ` : ''}${record?.entity_info?.product_sku_name}`?.trim()}
            </div>
            <div className="common-table-grey-subtext">
              <H3Text text={`Batch #${record?.approved_batch?.custom_batch_number || record?.approved_batch?.batch_number}`} className="" />
              {record?.approved_batch?.lot_number && <H3Text text={`LOT# ${record?.approved_batch?.lot_number}`} className="" />}
              {record?.approved_batch?.ar_number && <H3Text text={`AR# ${record?.approved_batch?.ar_number}`} className="" />}
            </div>
          </Fragment>
        ),
        className: !visibleColumns.PRODUCT_NAME.visible ? 'display-none' : '',
      },
      {
        title: 'QUALITY RULE',
        render: (text, record) => (
          <div className="associated-entity">
            {record?.quality_control_rules?.quality_control_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.QUALITY_CHECK_POINT.visible ? 'display-none' : '',
      },
      {
        title: 'Assignees',
        render: (text, record) => {
          const selectedUsers = record?.assignees?.map((assignee) => ({
            userId: assignee?.user_id,
            title: assignee?.first_name,
            identity: assignee?.identity,
          }));
          return (
            <React.Fragment>
              <SelectUser
                dontShowUnassigned
                selectedUsers={selectedUsers}
                onSelect={(userId) => {
                  setCurrentPage(1)
                  const defaultAssignees = Array.isArray(record?.default_assignees) ? record.default_assignees : [];

                  const selectedUsersNew = defaultAssignees.includes(userId)
                    ? defaultAssignees
                    : [...defaultAssignees, userId];

                  const tenantId = record?.quality_control_rules?.tenant_id;
                  const qualityCheckId = record?.quality_check_id;

                  const payload = {
                    default_assignees: selectedUsersNew,
                    tenant_id: tenantId,
                    quality_check_id: qualityCheckId,
                  };

                  updateQualityCheckAssignees(payload, () => setCall((prev) => !prev));
                }}
                onRemove={(userId) => {
                  // Filter out the userId from the default_assignees array
                  const selectedUsersNew = record?.default_assignees.filter((id) => id !== userId);

                  const payload = {
                    default_assignees: selectedUsersNew,
                    tenant_id: record?.quality_control_rules?.tenant_id,
                    quality_check_id: record?.quality_check_id,
                  };
                  updateQualityCheckAssignees(payload, () => setCall(!call));
                }}
                disabled={record?.status === 'COMPLETED'}
                removeAddUser={record?.status === 'COMPLETED' || (!Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.UPDATE, user))}
              />
            </React.Fragment>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ASSIGNEES?.visible ? 'display-none' : '',
      },
      {
        title: 'REFERENCE#',
        render: (text, record) => (
          <Fragment>
            <div className="qc-tags__wrapper">
              <div className="qc-tags">
                {record?.entity_name === 'good_receiving_note' ? 'Goods Receiving Note' : (record?.entity_name === 'manufacturing_order' ? 'Manufacturing Order' : (record?.is_qc_retest && 'Retest'))}
              </div>
            </div>
            <div style={{ marginTop: '5px' }}>
              {record?.entity_name === 'manufacturing_order'
                ? (
                  ((record?.entity_info?.is_restricted && record?.entity_info?.mo_users.includes(user?.user_id)) || (record?.entity_info?.mo_users === null))
                    ? (
                      <div className="associated-entity">
                        <Link target="_blank" to={`/production/manufacturing-orders/view/${record?.entity_id}`}>{record?.reference_id}</Link>
                      </div>
                    )
                    : (
                      <div className="associated-entity" style={{ color: 'rgba(0, 0, 0, 0.88)' }}>{record?.reference_id}</div>
                    )
                ) : (
                  record?.entity_name === 'good_receiving_note' ? (
                    <div className="associated-entity"><Link target="_blank" to={`/purchase/goods-receiving/view/${record?.entity_id}`}>{record?.reference_id}</Link></div>
                  ) : '-'
                )}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.REFERENCE_CODE.visible ? 'display-none' : '',
      },
      {
        title: 'BATCH QTY',
        render: (text, record) => (
          <div>
            {record?.original_qty ? `${Number(record?.original_qty) + Number(record?.sample_quantity)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.BATCH_QTY.visible ? 'display-none' : '',
      },
      {
        title: 'SAMPLE QTY',
        render: (text, record) => (
          <div>
            {record?.sample_quantity ? `${Number(record?.sample_quantity)} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.BATCH_QTY.visible ? 'display-none' : '',
      },
      {
        title: 'APPROVED',
        render: (text, record) => (
          <div>
            {record?.approved_qty ? `${record?.approved_qty} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.APPROVED_QTY.visible ? 'display-none' : '',
      },
      {
        title: 'REJECTED',
        render: (text, record) => (
          <div>
            {record?.rejected_qty ? `${record?.rejected_qty} ${record?.entity_info?.uom_info?.uqc?.toProperCase() || ''}` : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.REJECTED_QTY.visible ? 'display-none' : '',
      },
      {
        title: 'BATCH EXPIRY',
        render: (text, record) => (
          <div className="column-date">
            {record?.expiry_date === INFINITE_EXPIRY_DATE ? '-' : dayjs(record?.expiry_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.BATCH_EXPIRY.visible ? 'display-none' : '',
      },
      {
        title: 'BATCH COST PRICE',
        render: (text, record) => (
          <div className="column-amount">
            {record?.entity_info?.cost_price ? ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view batch cost price" /> : MONEY(record?.entity_info?.cost_price)) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.BATCH_COST_PRICE.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="column-date">
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.CREATED_DATE.visible ? 'display-none' : '',
      },
      {
        title: 'COMPLETION DATE',
        render: (text, record) => (
          <div className="column-date">
            {record?.approved_at ? toISTDate(record?.approved_at).format('DD/MM/YYYY hh:mm A') : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.COMPLETION_DATE.visible ? 'display-none' : '',
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        render: (text, record) => (
          <div className="list__actions">
            {!isPortrait && (
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  handleDrawerState(record);
                }}
              >
                View
              </div>
            )}
            <Dropdown
              className="list__actions-button list__actions-button-download"
              menu={{
                items: [
                  {
                    label: record?.status === 'COMPLETED' ? 'QC Report' : 'QC Requisition Slip',
                    key: 'download_qc',
                  },
                  {
                    label: 'Certificate of Analysis',
                    key: 'download_coa',
                    disabled: !record?.approved_qty,
                  },
                ],
                onClick: ({ key }) => {
                  switch (key) {
                    case 'download_qc':
                      getDownloadQualityChecks(record?.quality_control_rules?.tenant_id, record?.quality_check_id, '', '', user?.user_id);
                      break;
                    case 'download_coa':
                      if (record?.quality_check_id) {
                        downloadDocument({
                          url: `${Constants.QUALITY_CHECK_COA}?quality_check_id=${record?.quality_check_id}&tenant_id=${record?.quality_control_rules?.tenant_id}`,
                          document_type: 'CERTIFICATE_OF_ANALYSIS',
                          document_number: record?.quality_check_id,
                          key: uuidv4(),
                        });
                      }
                      break;
                    default:
                      break;
                  }
                },
              }}
              arrow
              trigger="click"
            >
              <span onClick={(e) => e.preventDefault()}>
                <FontAwesomeIcon
                  icon={faDownload}
                  className="action-button-text"
                />
              </span>
            </Dropdown>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
      },
    ];
    return qualityCheckColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, word, status, start, end, tenant, entityType, defaultAssignee, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (tenant) url += `&tenant=${tenant}`;
    if (entityType) url += `&entity=${entityType}`;
    if (defaultAssignee) url += `&defaultAssignee=${defaultAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    history.push(url);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    // const restrictAccountManagerPermissionCheck = (window.location.href.includes('/estimate')) ? (user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.restrict_estimate_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_estimate)) : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_so));

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'defaultAssignee',
        filter_value: Helpers.getValueFromUrl('defaultAssignee') ? Helpers.getValueFromUrl('defaultAssignee')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim() || '',
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase() || '',
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'entity',
        filter_value: Helpers.getValueFromUrl('entity') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : [],
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = Helpers.getValueFromUrl('onlyApprover') === 'true' ? true : false;

    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'defaultAssignee',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: [],
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'entity',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.QUALITY_CHECKS,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setSelectedFilterView(systemDefaultUserView);
        // let onlyApprover = Helpers.getValueFromUrl('onlyApprover') === 'true' ? true : false;
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // const defaultAssigneeId = String(user?.user_id);
        // if (onlyApprover) {
        //   setSelectedAssignee(defaultAssigneeId ? defaultAssigneeId?.split(',')?.map((item) => ({
        //     userId: parseInt(item),
        //     title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //     identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        //   })) : []);
        // }
      });
    }
  }, []);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setLimit(Helpers.getValueFromUrl('limit') || limit);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setSelectedEmails([user?.email]);
  //     setSelectedStatus(Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : []);
  //     setStartDateMomentEpoch(Number(Helpers.getValueFromUrl('start')));
  //     setEndDateMomentEpoch(Number(Helpers.getValueFromUrl('end')));
  //     setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
  //     setSelectedEntityType(Helpers.getValueFromUrl('entity'));
  //     setIsUserReady(true);

  //     let onlyApprover = Helpers.getValueFromUrl('onlyApprover') === 'true' ? true : false;
  //     getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
  //       const defaultAssigneeId = String(user?.user_id);
  //       if (onlyApprover) {
  //         setSelectedAssignee(defaultAssigneeId ? defaultAssigneeId?.split(',')?.map((item) => ({
  //           userId: parseInt(item),
  //           title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
  //           identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
  //         })) : []);
  //       }
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.defaultAssignee);
        setSelectedEntityType(tempFilterValues.entity);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, startDate, endDate, selectedTenant, selectedEntityType, selectedAssignee, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getQualityChecks(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)?.join(','), '', selectedEntityType, selectedStatus, '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), searchKeyword, startDate, endDate, '', Helpers.getValueFromUrl('defaultAssignee'));
    }
  }, [searchKeyword, currentPage, limit, selectedTenant, call, selectedStatus, startDate, endDate, selectedEntityType, selectedAssignee, orderDateSelectedIntervalDateRangeType]);

  const downloadHandler = () => {
    getQualityCheckReport(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)?.join(','), selectedEntityType, selectedStatus, startDate, endDate, selectedEmails, 'send_email', user?.user_id, () => { setOpenPopover(false); });
  };

  const statusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "COMPLETED", label: "Completed" }
  ];

  const opertationTypeOptions = [
    { value: "manufacturing_order", label: "Manufacturing Order" },

    { value: "good_receiving_note", label: "Goods Receipt" }

    // { value: "good_receiving_note_external_stock_transfer", label: "External Transfer Receipt" },
    // { value: "good_receiving_note_internal_stock_transfer", label: "Internal Transfer Receipt" }
    // { value: "good_receiving_note", label: "Purchase Receipt" }
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Quality Checks..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.defaultAssignee);
                    setSelectedEntityType(tempFilterValues.entity);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.QUALITY_CHECKS}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }}>
                    Search Results for
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedStatus && selectedStatus?.map((item, index) => (
                  <Tag closable onClose={() => setSelectedStatus(selectedStatus.filter((tId) => tId !== item))} color="#2d7df7">
                    {' '}
                    Status -
                    &nbsp;
                    <span><b>{item?.replaceAll('_', ' ').toUpperCase()}</b></span>
                    {' '}
                  </Tag>
                ))}
                {selectedEntityType && (
                  <Tag closable onClose={() => setSelectedEntityType('')} color="#2d7df7">
                    {' '}
                    Operation Type -
                    &nbsp;
                    <span><b>{selectedEntityType?.replaceAll('_', ' ').toUpperCase()}</b></span>
                    {' '}
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">

                    <div className="doc-list__table-header__left">
                      {`${(qualityChecks && qualityChecks?.count) ? qualityChecks?.count : '0'} Quality Checks`}
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                          />
                        </div>
                        {qualityChecks?.count > 0 && (
                          <Popover
                            placement="bottom"
                            trigger="click"
                            title={<div>Please provide your email address</div>}
                            open={openPopover}
                            onOpenChange={() => setOpenPopover(!openPopover)}
                            content={(
                              <React.Fragment>
                                <div>
                                  <PRZSelect
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    mode="tags"
                                    filterOption={false}
                                    value={selectedEmails}
                                    onChange={(value) => setSelectedEmails(value)}
                                    disabled={getQualityCheckReportLoading}
                                    maxTagCount="responsive"
                                    style={{
                                      width: '300px',
                                      height: 'auto !important',
                                    }}
                                  >

                                    {selectedEmails.length > 0 ? (
                                      selectedEmails.map((item) => (
                                        <Option key={item} value={item}>
                                          {item}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option key={user?.email} value={user?.email}>
                                        {user?.email}
                                      </Option>
                                    )}

                                  </PRZSelect>
                                </div>
                                <div>
                                  <H3Button
                                    text="Send"
                                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                    onClick={() => { downloadHandler(); }}
                                    customClass="email-submit"
                                    isLoading={getQualityCheckReportLoading}
                                    disabled={getQualityCheckReportLoading}
                                  >
                                    Send

                                  </H3Button>
                                </div>

                              </React.Fragment>
                            )}
                          >
                            <div
                              className={`download-btn ${getQualityCheckReportLoading ? 'download-btn__disabled' : ''}`}
                              onClick={() => {
                                setOpenPopover(true);
                              }}
                            >
                              <H3Text
                                text={(
                                  <FontAwesomeIcon icon={faDownload} />
                                )}
                                className="action-button"
                              />
                            </div>
                          </Popover>
                        )}
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                      </div>
                      <Dropdown
                        overlay={(
                          <div className="header__filter__container">
                            <div className="header__filter__container__title">
                              Apply Filters
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title"> Business Unit </div>
                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                isMultiple
                                onChange={(value) => {
                                  if (value === 'All') {
                                    setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ));
                                    setCurrentPage(1);
                                  } else {
                                    setSelectedTenant(value);
                                    setCurrentPage(1);
                                  }
                                }}
                                placeholder="Select Business Unit"
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title">Status </div>
                              <PRZSelect
                                value={selectedStatus}
                                onChange={(value) => {
                                  setSelectedStatus(value);
                                  setCurrentPage(1);
                                }}
                                placeholder="Search by Status.."
                                mode="multiple"
                                options={statusOptions}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title">Operation Type </div>
                              <PRZSelect
                                value={selectedEntityType}
                                onChange={(value) => {
                                  setSelectedEntityType(value);
                                  setCurrentPage(1);
                                }}
                                placeholder="Search by Status.."
                                options={opertationTypeOptions}
                              />
                            </div>
                          </div>
                        )}
                      >
                        <div className="doc-list__action-buttons">
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                      </Dropdown>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem('prcz-page-columns-qc', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-qc', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={qualityChecksLoading}
                showHeader
                size="small"
                scroll={{ x: 'max-content' }}
                columns={getQualityCheckColumns()}
                dataSource={qualityChecks && qualityChecks?.quality_checks ? qualityChecks?.quality_checks : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: qualityChecks ? qualityChecks?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showApproveQualityCheck}
        width="900px"
        onClose={() => {
          setShowApproveQualityCheck(false);
          setCall(!call);
        }}
        destroyOnClose
      >
        <ApproveQC
          selectedQC={qcData}
          callback={() => {
            setCall(!call);
            setShowApproveQualityCheck(false);
          }}
          onClose={() => {
            setShowApproveQualityCheck(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedQCPointForMobile?.qc_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedQCPointForMobile?.description}
          customFields={selectedQCPointForMobile?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedQCPointForMobile, MONEY, priceMasking })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers, QualityCheckReducers, TenantReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  qualityChecksLoading: QualityCheckReducers.qualityChecksLoading,
  qualityChecks: QualityCheckReducers.qualityChecks,
  getQualityCheckReportLoading: QualityCheckReducers.getQualityCheckReportLoading,
  orgUsers: TenantReducers.orgUsers,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getQualityChecks: (tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId) => dispatch(
    QualityCheckActions.getQualityChecks(tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId, defaultAssigneeId),
  ),
  getDownloadQualityChecks: (tenantId, qualityCheckId, entityName, entityId, userId) => dispatch(
    QualityCheckActions.getDownloadQualityChecks(tenantId, qualityCheckId, entityName, entityId, userId),
  ),
  getQualityCheckReport: (tenantId, entityName, status, qcType, startDate, endDate, operationType, userId, callback) => dispatch(QualityCheckActions.getQualityCheckReport(tenantId, entityName, status, qcType, startDate, endDate, operationType, userId, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  updateQualityCheckAssignees: (payload, callback) => dispatch(QualityCheckActions.updateQualityCheckAssignees(payload, callback)),
});

ListQualityChecks.propTypes = {
  getQualityChecks: PropTypes.func,
  getDownloadQualityChecks: PropTypes.func,
  qualityChecks: PropTypes.any,
  user: PropTypes.any,
  qualityChecksLoading: PropTypes.bool,
  history: PropTypes.func,
  MONEY: PropTypes.func,
  getQualityCheckReport: PropTypes.func,
  getQualityCheckReportLoading: PropTypes.bool,
  downloadDocument: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListQualityChecks));
